import { conns } from '@cfg/axiosConfig.tsx';
import {
  Offer,
  EvaluateRequest,
  EvaluateResponse,
  PreviewRequest,
  PreviewResponse,
  PromotionCreatePayload,
} from '@eshop/types/offers.types.ts';

const URL = 'eshop:dashboard:offers';

export const OffersApi = {
  async list(): Promise<Offer[]> {
    const { data } = await conns<Offer[]>(URL).get();
    return data;
  },
  async get(id: number): Promise<Offer> {
    const { data } = await conns<Offer>(URL, [id]).get();
    return data;
  },
  async create(payload: PromotionCreatePayload): Promise<Offer> {
    const { data } = await conns<Offer>(URL).post(payload);
    return data;
  },
  async update(id: number, payload: Partial<PromotionCreatePayload>): Promise<Offer> {
    const { data } = await conns<Offer>(URL, [id]).put(payload);
    return data;
  },
  async updateStatus(id: number, active: boolean): Promise<Offer> {
    const { data } = await conns<Offer>(URL, [id]).put({ active });
    return data;
  },
  async activate(id: number): Promise<Offer> {
    const { data } = await conns<Offer>(URL, [id, 'activate']).post();
    return data;
  },
  async discard(id: number, reason = 'discarded_by_user'): Promise<Offer> {
    const { data } = await conns<Offer>(URL, [id, 'discard']).post({ reason });
    return data;
  },
  async remove(id: number): Promise<void> {
    await conns(URL, [id]).delete();
  },
  async preview(body: PreviewRequest): Promise<PreviewResponse> {
    const { data } = await conns<PreviewResponse>(URL, ['preview']).post(body);
    return data;
  },
  async applyCoupon(body: EvaluateRequest): Promise<EvaluateResponse> {
    const { data } = await conns<EvaluateResponse>(URL, ['coupon', 'apply']).post(body);
    return data;
  },
  async removeCoupon(body: EvaluateRequest): Promise<EvaluateResponse> {
    const { data } = await conns<EvaluateResponse>(URL, ['coupon', 'remove']).post(body);
    return data;
  },
  async evaluate(body: EvaluateRequest, signal?: AbortSignal): Promise<EvaluateResponse> {
    for (let attempt = 0; attempt < 3; attempt += 1) {
      try {
        const { data } = await conns<EvaluateResponse>(URL, ['evaluate']).post(body);
        return data;
      } catch (err) {
        if (attempt === 2 || signal?.aborted) {
          throw err;
        }
        await new Promise((r) => setTimeout(r, (attempt + 1) * 500));
      }
    }
    throw new Error('Failed to evaluate');
  },
};
